import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rl_session_token";
export const getStoredToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setStoredToken = (token) => {
  try { token ? localStorage.setItem(TOKEN_KEY, token) : localStorage.removeItem(TOKEN_KEY); } catch {}
};

export const api = axios.create({
  baseURL: API,
  timeout: 180000,
  // NOTE: withCredentials is intentionally OFF.
  // (1) We auth via Authorization: Bearer (stored in localStorage), not cookies.
  // (2) Chrome's strict CORS forbids "Access-Control-Allow-Origin: *" combined
  //     with "Allow-Credentials: true" — production ingress sometimes returns
  //     "*" for the origin, which would surface in axios as "Network Error"
  //     on the very first sign-in (before any cookie exists). Bearer is fully
  //     sufficient and avoids that whole class of bug.
});

// Attach Bearer token on every request as a fallback for browsers that block
// 3rd-party cookies (Chrome's default since 2024). The backend already accepts
// either the session_token cookie OR Authorization: Bearer header.
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function evaluateResume({ resumeText, file, jobDescription, targetRole, sourceType, lang }) {
  const form = new FormData();
  if (resumeText) form.append("resume_text", resumeText);
  if (file) form.append("file", file);
  if (jobDescription) form.append("job_description", jobDescription);
  if (targetRole) form.append("target_role", targetRole);
  if (sourceType) form.append("source_type", sourceType);
  if (lang) form.append("lang", lang);
  const { data } = await api.post("/resumes/evaluate", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function getEvaluation(id) {
  const { data } = await api.get(`/resumes/${id}`);
  return data;
}

export async function listEvaluations() {
  const { data } = await api.get(`/resumes`);
  return data;
}

export async function improveResume(id) {
  const { data } = await api.post(`/resumes/${id}/improve`);
  return data;
}

export async function deleteEvaluation(id) {
  const { data } = await api.delete(`/resumes/${id}`);
  return data;
}

export async function getProductHuntInfo() {
  const { data } = await api.get(`/product-hunt/info`);
  return data;
}

export async function subscribeEmail(email, source = "landing") {
  const { data } = await api.post(`/subscribers`, { email, source });
  return data;
}
